export const AUTH_CONFIG = {
  domain: 'diribet.eu.auth0.com',
  clientId: 'yVMmO8Xr0qfhI5HEMczsAueAdQHDikHO',
  callbackUrl: 'https://license.chystat.com/callback',
  apiUrl: 'https://license.chystat.com',
  silentAuthRedirect: 'https://license.chystat.com/silent-auth.html'
};
